<template>
   <div class="wrapper">
      <div>
         <CRow class="mt-3">
            <CCol sm="12">
               <CCard>
                  <CCardBody>
                     <div class="row">
                        <div class="col-md-12">
                           <CCol>
                              <h2>Participant</h2>
                           </CCol>
                           <div class="card">
                              <div class="card-body">
                                 <Datatable
                                    :items="items"
                                    :fields="fields"
                                    :meta="meta"
                                    @per_page="handlePerPage"
                                    @pagination="handlePagination"
                                    @search="handleSearch"
                                    @sort="handleSort"
                                    @is_active="handleIsActive"
                                    :btn_show="true"
                                    :btn_edit="true"
                                    :btn_deactivate="true"
                                    :btn_reactivate="true"
                                    :btn_destroy="false"
                                    @show="handleShow"
                                    @attend="handleAttend"
                                    @edit="handleEdit"
                                    @deactivate="handleDeactivate"
                                    @reactivate="handleReactivate"
                                    @destroy="handleDestroy"
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </CCardBody>
               </CCard>
            </CCol>
         </CRow>
         <alertmodal></alertmodal>
         <participantdetail></participantdetail>
         <participantattend></participantattend>
      </div>
   </div>
</template>

<script>
import Datatable from "@/components/datatables_schedule_attendance.vue";
import axios from "axios";

import classschedule from "@/services/class_schedule";
import participantdetail from "./schedule_detail_participant.vue";
import participantattend from "./schedule_attend.vue";
import alertmodal from "@/views/alert/modal.vue";
import EventBus from "@/eventBus";
import store from "@/store.js";

const token = localStorage.getItem("token");

export default {
   name: "SectionTables",
   components: { alertmodal, Datatable, participantattend, participantdetail },
   data() {
      return {
         form: {
            name: "",
         },
         updateSubmit: false,
         largeModal: false,

         //fungsi yang harus digunakan
         //start
         fields: [
            { key: "people_name", sortable: false },
            { key: "class_batch", sortable: false },
            { key: "class_template", sortable: false },
            { key: "class_schedule", sortable: false },
            { key: "attend_date", sortable: false },
            { key: "is_active", sortable: false },
            { key: "action", label: "Action", sortable: false },
         ],
         items: [],
         meta: [],
         current_page: 1,
         per_page: 10,
         search: "",
         sortBy: " class_participant.created_at",
         sortByDesc: false,
         is_active: 1,
         //end
      };
      //end
   },

   created() {
      //this.loadData()
   },
   mounted() {
      this.loadData();

      EventBus.$on("TABLE_UPDATE", (data) => {
         if (data) {
            this.loadData();
         }
      });
   },

   methods: {
      openShow: function(uuid) {
         var params = {
            title: "Detail Personal Information",
            mode: "detail",
            data: uuid,
         };
         EventBus.$emit("OPEN_SHOW_PARTICIPANT", params);
      },
      openAttend: function(uuid, batch_id, template_id, schedule_id) {
         var params = {
            title: "Participant Attend",
            mode: "detail",
            data: uuid,
            batch_id,
            template_id,
            schedule_id,
         };
         EventBus.$emit("OPEN_SHOW_ATTEND", params);
      },

      loadData() {
         let current_page = this.search == "" ? this.current_page : 1;
         var params = {
            page: this.current_page,
            per_page: this.per_page,
            search: this.search,
            sortby: this.sortBy,
            sortbydesc: this.sortByDesc ? "DESC" : "ASC",
            is_active: this.is_active,
            batch: this.$route.query.bid,
            template: this.$route.query.tid,
            schedule: this.$route.query.sid
         };

         classschedule
            .getParticipantDataSource(params)
            .then((res) => {
               let getData = res.data;
               this.items = getData.data;
               //this.is_active = res.is_active
               this.meta = {
                  total: getData.total,
                  current_page: getData.current_page,
                  per_page: getData.per_page,
                  from: getData.from,
                  to: getData.to,
                  is_active: res.is_active,
               };
            })
            .catch((err) => {
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            });
      },

      handlePerPage(val) {
         this.per_page = val;
         this.loadData();
      },

      handlePagination(val) {
         this.current_page = val;
         this.loadData();
      },

      handleSearch(val) {
         this.search = val;
         this.current_page = 1;
         this.loadData();
      },

      handleSort(val) {
         this.sortBy = val.sortBy;
         this.sortByDesc = val.sortDesc;
         this.loadData();
      },

      handleIsActive(val) {
         this.is_active = val;
         this.loadData();
      },

      ////HANDLE FUNCTION BUTTON ACTION////
      handleShow(val) {
         this.openShow(val);
      },
      handleAttend(val, batch_id, template_id, schedule_id) {
         console.log(val, batch_id, template_id, schedule_id, "nilai");
         this.openAttend(val, batch_id, template_id, schedule_id);
      },
      handleEdit(val) {
         this.openModalEdit(val);
      },
      handleDeactivate(val) {
         this.deactivate(val);
      },
      handleReactivate(val) {
         this.reactivate(val);
      },
      handleDestroy(val) {
         this.destroy(val);
      },
   },
};
</script>
